<template>
  <div class="appBody bg-grey-light">
    <little-header></little-header>
    <div class="ml-12 mr-12 mt-12p images"
         v-if="!isLoading && pageTotalNum">
      <!--      <div class="tools">-->
      <!--        <span class="" @click="prePage">上一页</span>-->
      <!--        <span class="" @click="nextPage">下一页</span>-->
      <!--        <div class="page">{{pageNum}}/{{pageTotalNum}} </div>-->
      <!--      </div>-->
      <pdf
        v-for="i in pageTotalNum"
        :key="i"
        :src="pdfSrc"
        :page="i"
        @page-loaded="curPageNum=$event"
        @link-clicked="page = $event"
      >
      </pdf>
    </div>
    <van-loading class="my-5" v-else size="24px" vertical>加载中...</van-loading>
    <little-footer></little-footer>
  </div>
</template>

<script>
  import pdf from "vue-pdf";
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import LittleHeader from "@/components/littleHeader";
  import {mapState} from "vuex";
  import Vue from 'vue';
  import {Loading} from 'vant';

  Vue.use(Loading);
  export default {
    name: "docDetail",
    data() {
      return {
        sessionId: '',
        pageNum: 1,       // pdf文件页码
        pageTotalNum: undefined,
        curPageNum: 0,
        fileType: 'pdf',      // 文件类型
        pdfSrc: '',
        isLoading: true,
        isFullScreen: false,
      }
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl
      })
    },
    mounted() {
      this.sessionId = this.$route.params['id'];
      this.loadData();
    },
    components: {
      LittleHeader,
      littleFooter,
      pdf
    },
    methods: {
      loadData() {
        this.isLoading = true;
        this.$store.dispatch('getSessionDocForLearnerUrl', {id: this.sessionId}).then(
          (res) => {
            if (res) {
              this.isLoading = false;
              this.docObj = res;
              if (this.docObj.creatorUser && this.docObj.creatorUser.avatarUrl) {
                this.avatarUrl = this.uploadresUrl + this.docObj.creatorUser.avatarUrl;
              }
              this.loadPdf();

            }
          }
        );
      },
      loadPdf() {
        this.pdfSrc = pdf.createLoadingTask(window.location.protocol + '//' + this.uploadresUrl + this.docObj.docResource.url);
        if (this.pdfSrc) {
          this.pdfSrc.promise.then(pdf => {
            this.pageTotalNum = pdf.numPages;
          }).catch((err) => {
            console.log(err);
          });

        }

      },

      // // 上一页函数，
      // prePage() {
      //   var page = this.pageNum;
      //   page = page > 1 ? page - 1 : this.pageTotalNum;
      //   this.pageNum = page;
      // },
      // // 下一页函数
      // nextPage() {
      //   var page = this.pageNum;
      //   page = page < this.pageTotalNum ? page + 1 : 1;
      //   this.pageNum = page;
      // },
    }
  }
</script>

<style scoped>

</style>
